/** 页面信息 */
export const routes = [{
    path: '/401',
    name: 'error_401',
    meta: {
        hideInMenu: true
    },
    component: () => import('@/views/shared/error-page/401.vue')
},{
    path: '*',
    name: 'error_404',
    meta: {
        hideInMenu: true
    },
    component: () => import('@/views/shared/error-page/404.vue')
}]

export default routes
